export default __webpack_public_path__ + "static/media/motoSmall.c38f6ac2.png";